import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=481becdc&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"
import style0 from "./UserLogin.vue?vue&type=style&index=0&id=481becdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481becdc",
  null
  
)

export default component.exports